import { EXAMPLE } from '../../../../components/FormManagementV2/variables/fieldCustomTypes';

import Example from './Example';

export default {
	[EXAMPLE]: Example,
};
